import { render, staticRenderFns } from "./SignUpCompleted.vue?vue&type=template&id=3c1a1f36"
import script from "./SignUpCompleted.vue?vue&type=script&lang=js"
export * from "./SignUpCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports